export class StoreWrapper {
  /**
   * Force PoS with an extId
   * for instance, this is used after url parsing in cora by setting a cookie
   *  @param {string} posExtId
   */
  // eslint-disable-next-line no-unused-vars
  setPos(posExtId) {
    throw new Error("You must implement 'setPos' for this retailer");
  }

  /**
   * @returns host POS ext_id
   */
  getPosExtId() {
    throw new Error("You must implement 'getPosExtId' for this retailer");
  }

  /**
   * action on invalid host POS (open store selector)
   */
  hookCallback() {
    throw new Error(
      "You must implement 'hookCallback' for this retailer"
    );
  }

  /**
   * force change pos
   */
  forcePosCallback() {
    console.warn('[Miam] Injector: forcePosCallback not defined - basket trandfer from third parties will not be available');
  }


  /**
   * @returns true if host store add is part of  AVAILABLE_SHELF
   */
  
  isAvailable() {
    return window.mealz.user?.device.matchMedia("(min-width: 1023px)").matches;
  }

  /**
   * to override if retailer do not use placeholder injection
   * @returns true if recipes should be injected on the page
   */
  availableOnPage() {
    return true;
  }
}
